/* Sex Shop Online — interacciones del tema */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Drawers ---------- */
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const focusable = drawer.querySelector('button, a, input');
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.dataset.drawerOpen));
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Buscador del header ---------- */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-search-toggle]');
    if (!toggle) return;
    e.preventDefault();
    const bar = $('#HeaderSearch');
    if (!bar) return;
    bar.classList.toggle('is-open');
    if (bar.classList.contains('is-open')) $('input', bar).focus();
  });

  /* ---------- Barra de anuncios (rotación en móvil) ---------- */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    let i = 0;
    items[0].classList.add('is-active');
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    let el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------- Carrito ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count > 0 ? count : '';
      el.dataset.count = count;
    });
  }

  function renderDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer-inner]');
    const current = $('[data-cart-drawer-inner]');
    if (fresh && current) current.replaceWith(fresh);
  }

  async function refreshCount() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      updateCount(cart.item_count);
    } catch (err) { /* sin conexión */ }
  }

  async function addToCart(formData, button) {
    if (button) button.classList.add('is-loading');
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(window.theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        toast(data.description || data.message || 'No se pudo agregar el producto');
        return;
      }
      if (window.theme.cartType === 'page') {
        window.location.href = window.theme.routes.cart_url;
        return;
      }
      if (data.sections) renderDrawer(data.sections['cart-drawer']);
      await refreshCount();
      openDrawer(document.getElementById('CartDrawer'));
    } catch (err) {
      toast('Error de conexión, intenta nuevamente');
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(new FormData(form), form.querySelector('[type="submit"]'));
  });

  document.addEventListener('click', (e) => {
    const quick = e.target.closest('[data-quick-add]');
    if (!quick) return;
    e.preventDefault();
    const fd = new FormData();
    fd.append('id', quick.dataset.quickAdd);
    fd.append('quantity', '1');
    addToCart(fd, quick);
  });

  async function changeLine(line, quantity) {
    const inner = $('[data-cart-drawer-inner]');
    if (inner) inner.style.opacity = '.55';
    try {
      const res = await fetch(window.theme.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (data.status) toast(data.description || 'No hay más stock disponible');
      if (data.sections) renderDrawer(data.sections['cart-drawer']);
      updateCount(data.item_count != null ? data.item_count : 0);
    } catch (err) {
      toast('Error de conexión');
      if (inner) inner.style.opacity = '';
    }
  }

  // Cantidades: botones +/- (drawer usa AJAX, página/producto solo cambian el input)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    e.preventDefault();
    const wrap = btn.closest('.quantity');
    const input = $('input', wrap);
    const min = parseInt(input.min || '0', 10);
    const next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qtyStep, 10));
    input.value = next;
    if (wrap.dataset.line) {
      changeLine(parseInt(wrap.dataset.line, 10), next);
    } else if (wrap.closest('form[data-cart-page]')) {
      wrap.closest('form').submit();
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('.quantity input');
    if (!input) return;
    const wrap = input.closest('.quantity');
    if (wrap.dataset.line) changeLine(parseInt(wrap.dataset.line, 10), parseInt(input.value, 10) || 0);
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-remove-line]');
    if (!rm) return;
    e.preventDefault();
    changeLine(parseInt(rm.dataset.removeLine, 10), 0);
  });

  /* ---------- Galería de producto ---------- */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    e.preventDefault();
    const gallery = thumb.closest('[data-gallery]');
    const main = $('[data-gallery-main] img', gallery);
    if (main) {
      main.src = thumb.dataset.full;
      main.removeAttribute('srcset');
      main.alt = thumb.dataset.alt || main.alt;
    }
    $$('[data-gallery-thumb]', gallery).forEach((t) => t.classList.toggle('is-active', t === thumb));
  });

  /* ---------- Selector de variante ---------- */
  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-variant-select]');
    if (!select) return;
    const opt = select.options[select.selectedIndex];
    const form = select.closest('form');
    const priceEl = document.querySelector('[data-product-price]');
    if (priceEl && opt.dataset.priceHtml) priceEl.innerHTML = opt.dataset.priceHtml;
    const btn = form && form.querySelector('[type="submit"]');
    if (btn) {
      const available = opt.dataset.available === 'true';
      btn.disabled = !available;
      btn.textContent = available ? btn.dataset.addLabel : btn.dataset.soldLabel;
    }
    if (opt.dataset.image) {
      const thumb = document.querySelector('[data-gallery-thumb][data-media-id="' + opt.dataset.image + '"]');
      if (thumb) thumb.click();
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', opt.value);
    window.history.replaceState({}, '', url);
  });

  /* ---------- Filtros y orden (auto-envío) ---------- */
  document.addEventListener('change', (e) => {
    const el = e.target.closest('[data-auto-submit]');
    if (!el) return;
    const form = el.form || el.closest('form');
    if (form) form.submit();
  });
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-filters-toggle]');
    if (!t) return;
    e.preventDefault();
    const f = document.getElementById('CollectionFilters');
    if (f) {
      f.classList.toggle('is-open');
      t.setAttribute('aria-expanded', f.classList.contains('is-open'));
    }
  });

  /* ---------- Verificación de edad ---------- */
  function initAgeGate() {
    const gate = $('[data-age-gate]');
    if (!gate) return;
    let ok = false;
    try { ok = window.localStorage.getItem('ageVerified') === '1'; } catch (err) { ok = document.cookie.indexOf('ageVerified=1') > -1; }
    if (ok || window.Shopify && window.Shopify.designMode && gate.dataset.hideInEditor === 'true') return;
    gate.classList.add('is-visible');
    document.body.classList.add('is-locked');
    $('[data-age-confirm]', gate).addEventListener('click', () => {
      try { window.localStorage.setItem('ageVerified', '1'); } catch (err) { /* modo privado */ }
      document.cookie = 'ageVerified=1; max-age=2592000; path=/; SameSite=Lax';
      gate.classList.remove('is-visible');
      document.body.classList.remove('is-locked');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAgeGate);
  else initAgeGate();

  /* ---------- Recomendaciones de producto ---------- */
  $$('[data-recommendations-url]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.recommendationsUrl);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations-url]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (err) { /* opcional */ }
  });

  /* ---------- Editor de temas: refrescar contador ---------- */
  document.addEventListener('shopify:section:load', refreshCount);
})();

/* v2: carruseles y slideshow */
(function () {
  'use strict';
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-carousel-btn]');
    if (!btn) return;
    const root = btn.closest('[data-carousel]');
    const track = root && root.querySelector('[data-carousel-track]');
    if (!track) return;
    const item = track.firstElementChild;
    const step = item ? item.getBoundingClientRect().width + 20 : track.clientWidth;
    track.scrollBy({ left: btn.dataset.carouselBtn === 'next' ? step : -step, behavior: 'smooth' });
  });

  function initSlideshow(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const track = root.querySelector('[data-slides]');
    const dots = Array.from(root.querySelectorAll('[data-slide-dot]'));
    const count = track ? track.children.length : 0;
    if (!track || count < 2) return;
    const current = () => Math.round(track.scrollLeft / track.clientWidth);
    const go = (i) => track.scrollTo({ left: ((i + count) % count) * track.clientWidth, behavior: 'smooth' });
    track.addEventListener('scroll', () => {
      const i = current();
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    }, { passive: true });
    dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
    root.querySelectorAll('[data-slide-arrow]').forEach((a) => a.addEventListener('click', () => go(current() + (a.dataset.slideArrow === 'next' ? 1 : -1))));
    const speed = parseInt(root.dataset.autoplay || '0', 10);
    if (speed > 0 && !(window.Shopify && window.Shopify.designMode)) {
      let timer = setInterval(() => go(current() + 1), speed * 1000);
      root.addEventListener('pointerenter', () => clearInterval(timer));
      root.addEventListener('pointerleave', () => { clearInterval(timer); timer = setInterval(() => go(current() + 1), speed * 1000); });
    }
  }
  const boot = () => document.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
